import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["icon"]
  static values = {
    labelDark: String,
    labelLight: String
  }

  connect() {
    const saved = localStorage.getItem("gocase-theme")
    if (saved === "dark") {
      document.documentElement.setAttribute("data-theme", "dark")
    }
    this.updateIcon()
  }

  toggle() {
    const current = document.documentElement.getAttribute("data-theme")
    const next = current === "dark" ? "light" : "dark"

    if (next === "dark") {
      document.documentElement.setAttribute("data-theme", "dark")
    } else {
      document.documentElement.removeAttribute("data-theme")
    }

    localStorage.setItem("gocase-theme", next)
    this.updateIcon()
  }

  updateIcon() {
    if (!this.hasIconTarget) return

    const isDark = document.documentElement.getAttribute("data-theme") === "dark"
    const label = isDark ? this.labelLightValue : this.labelDarkValue

    this.element.setAttribute("aria-label", label)
    this.element.setAttribute("title", label)

    if (isDark) {
      this.iconTarget.innerHTML = `<span class="material-symbols-outlined">light_mode</span>`
    } else {
      this.iconTarget.innerHTML = `<span class="material-symbols-outlined">dark_mode</span>`
    }
  }
}
